
const routes = {
    HOME: '/',
    VIRTUAL_SCROLLING: '/virtual-scrolling',
};

export default routes;
